module.exports = "<div class=\"container\">\n  <div class=\"text-justify\" [innerHTML]=\"content\" style=\"margin-bottom: 40px;\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/pages/doc/doc.component.html
// module id = ../../../../../src/app/pages/doc/doc.component.html
// module chunks = main